(function() {
    'use strict';
    
a3_cabin_reports.controller('CCMSCrewPositionCtrl', CCMSCrewPositionCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name CCMSCrewPositionCtrl
    * @description 
    *  Manages the CCMS Crew Position Modal View
    * @ngInject
    */
function CCMSCrewPositionCtrl($scope, $uibModalInstance, ModalDialogResultFactory, CCMSCrewPositionFactory, crew) {

		var result = ModalDialogResultFactory.createNew();

		if (crew == null) {
			result.Object = CCMSCrewPositionFactory.createNew();
			result.Object.IsManual = true;
			result.isInsertMode = true;
		} else {
			result.Object = CCMSCrewPositionFactory.fromObject(crew);
			result.isInsertMode = false;
		}

		$scope.crew = result.Object;

		$scope.ok = ok;
        $scope.cancel = cancel;
            
        /**
         * Close modal after u check position
         * @memberof CCMSCrewPositionCtrl
         */
        function ok() {
			if ((result.Object.CrewId == null) || (result.Object.CrewId == ''))
				result.Object.CrewId = '-';
			$uibModalInstance.close(result);
		}

        /**
         * Close Modal
         * @memberof CCMSCrewPositionCtrl
         */
        function cancel() {
			$uibModalInstance.close(null);
		}

	}

})();